export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";